// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__XkWRf","itemWrapper":"List_itemWrapper__ChlCY","itemContent":"List_itemContent__O0JnO","detail":"List_detail__xFiak"};